import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  wrapperTag: ({ spacing }) => css`
    margin-bottom: ${spacing.xs};
  `,

  containerData: ({ spacing }) => css`
    display: flex;
    align-items: center;
    margin-bottom: ${spacing.xxs};
    p {
      margin-left: ${spacing.xxs};
    }
  `,
})

export default useStyles
